import { render, staticRenderFns } from "./TitleText.vue?vue&type=template&id=a4383888&scoped=true&"
import script from "./TitleText.vue?vue&type=script&lang=js&"
export * from "./TitleText.vue?vue&type=script&lang=js&"
import style0 from "./TitleText.vue?vue&type=style&index=0&id=a4383888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4383888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4383888')) {
      api.createRecord('a4383888', component.options)
    } else {
      api.reload('a4383888', component.options)
    }
    module.hot.accept("./TitleText.vue?vue&type=template&id=a4383888&scoped=true&", function () {
      api.rerender('a4383888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signUp/common/TitleText.vue"
export default component.exports